import { render, staticRenderFns } from "./MessageShortener.vue?vue&type=template&id=f2de7ebe&"
import script from "./MessageShortener.vue?vue&type=script&lang=js&"
export * from "./MessageShortener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports